import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { SecondaryText } from '@dreryk/react-components';

import { GoBackToAuthorizerChoiceLink } from '../shared/GoBackToAuthorizerChoiceLink';
import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

const StyledGoBackToAuthorizerChoiceLink = styled(GoBackToAuthorizerChoiceLink)`
   display: inline;
`;
StyledGoBackToAuthorizerChoiceLink.displayName = 'StyledGoBackToAuthorizerChoiceLink';

type PatientDidntReceiveInformationProps = {
   readonly onGoBackToAuthorizerChoiceClick: VoidFunction;
};

export const PatientDidntReceiveInformation = (props: PatientDidntReceiveInformationProps): JSX.Element => {
   return (
      <SecondaryText
         testId={'patientDidntReceiveInformation'}
         text={
            <span>
               <Trans
                  i18nKey={prescriptionsHistoryDownloadTranslationKeys.patientDidntReceiveNotification}
                  components={{
                     goBackToAuthorizerChoiceLink: (
                        <StyledGoBackToAuthorizerChoiceLink onClick={props.onGoBackToAuthorizerChoiceClick} />
                     ),
                  }}
               />
            </span>
         }
      />
   );
};
